export const SETTING_YOU_ROUTE = '/settings/projects';

export const APP_UNAUTHORIZE_ROUTES = [
    {
      route: '/login', name: 'Login',
    }, {
      route: '/signup', name: 'Signup',
    }, {
      route: '/signupComplete', name: 'Signup Complete',
    }, {
      route: '/resetPassword', name: 'Reset Password',
    },
  ];
  
export const APP_ROUTES = [
    {
      icon: 'grid_view',
      route: '/',
      name: 'Dashboard',
    },
    { icon: 'smartphone', route: '/devices', name: 'Devices' },
  ];

export const CONDITIONAL_FEATURE_ROUTES = [
  { icon: 'add_moderator', route: '/build-security', name: 'Build Security' },
  { icon: 'add_moderator', route: '/integration', name: 'Integration' },
]

export const SECONDARY_ROUTES = [
      { icon: 'settings', route: '/settings', name: 'Risk Configuration' },
    { icon: 'user', route: '/user-management', name: 'User Management' },
]
  
export const SETTING_ITEM = {
    icon: 'settings', route: SETTING_YOU_ROUTE, name: 'Settings',
  };